import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import { MfaEmailNotEnabled } from "./mfa-email-not-enabled";
import { MfaEmailEnabled } from "./mfa-email-enabled";
import {MESSAGE_IDS} from 'constants/message-ids'

const styles = ({ spacing }) => {
    return {
        line: {
            display: "flex",
            marginBottom: spacing.unit * 2,
        },
        number: {
            marginRight: spacing.unit * 2,
        },
        verify: {
            marginTop: spacing.unit * 2,
        },
        key: {
            fontWeight: "bold",
        },
        qrCode:{
            marginTop:spacing.unit*2,
            height: "auto",
            margin: "0 auto",
            width: "256px",            
        },
        emailButton:{
            marginLeft: spacing.unit * 8, 
            marginBottom: spacing.unit * 2, 
        }
    };
};

class MfaEnableEmail extends Component {
    state = {  };


    render() {
        const  {enabled, messages}=this.props;
        const title=messages[MESSAGE_IDS.MFA.EMAIL_STEPS];
        const props={...this.props, title, enabled, messages}
        
        return <MfaEmailNotEnabled {...props}/>
    }
}

MfaEnableEmail = withStyles(styles)(MfaEnableEmail);

export { MfaEnableEmail };
